/**
 * @file 外部人员-审核页面
 * @author hukeke01
 */

import {rcAjax} from '../util';
import {
    GET_DATA_REVIEW_LIST,
    GET_DATA_REVIEW_DETAIL
} from './ActionTypes';

export function fetchDataReviewList(dispatch, params) {
    return rcAjax('GET', '/api/v1/cloud/censor/phoneimport/clist', params, {}, data => {
        dispatch({type: GET_DATA_REVIEW_LIST, data: data.data});
    });
}

export function fetchDataReviewDetail(dispatch, params) {
    return rcAjax('GET', '/api/v1/cloud/censor/phoneimport/dlist', params, {}, data => {
        dispatch({type: GET_DATA_REVIEW_DETAIL, data: data.data});
    });
}

export function fetchReviewCheckThrough(dispatch, id, params) {
    return rcAjax('POST', `/api/v1/cloud/censor/phoneimport/checkthrough?id=${id}`, {}, params, data => {
        dispatch({type: 'REVIEW_CHECK_THROUGH', data: data.data});
    });
}

export function fetchReviewDetailUpdate(dispatch, id, params) {
    return rcAjax('POST', `/api/v1/cloud/censor/phoneimport/detailupdate?id=${id}`, {}, params, data => {
        dispatch({type: 'REVIEW_DETAIL_UPDATE', data: data.data});
    });
}

export function fetchReviewFilterList(dispatch, params) {
    return rcAjax('GET', '/api/v1/cloud/censor/phoneimport/filter', params, {}, data => {
        dispatch({type: 'REVIEW_FILTER_LIST', data: data.data});
    });
}

export function fetchRegionList(dispatch, params) {
    return rcAjax('GET', '/api/v1/cloud/censor/custdata/region', params, {}, data => {
        dispatch({type: 'REGION_LIST', data: data.data});
    });
}